export const explorePageTabsIds = {
  goals: 'goals',
  keyResults: 'krs',
  initiatives: 'initiatives',
  activity: 'activity'
}
